import Vue from "vue";
import Router from "vue-router";
import core from "@/core";
import store from "@/store";

const Login = () => import("@/views/Login");
const Logout = () => import("@/views/Logout");
// const Register = () => import("@/views/Register");
const NotFound = () => import("@/views/errors/NotFound");
const NotSupportBrowser = () => import("@/views/errors/NotSupportBrowser");

// Containers
const TheContainer = () => import("@/containers/TheContainer");

// Views
const TomatoDiseaseAnalysis = () => import("@/views/TomatoDiseaseAnalysis");
const StrawberryDiseaseAnalysis = () => import("@/views/StrawberryDiseaseAnalysis");
const PaprikaDiseaseAnalysis = () => import("@/views/PaprikaDiseaseAnalysis");
const DiseaseInfo = () => import("@/views/DiseaseInfo");
const DiseaseInfoAddEdit = () => import("@/views/DiseaseInfoAddEdit");

Vue.use(Router);

const routes = [
  {
    path: "*",
    name: "notFound",
    component: NotFound,
    meta: {
      title: "병해충 영상진단",
    },
  },
  {
    path: "/error/not-support-browser",
    name: "notSupportBrowser",
    component: NotSupportBrowser,
    meta: {
      title: "병해충 영상진단",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "병해충 영상진단 - 로그인",
    },
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   component: Register,
  //   meta: {
  //     title: "병해충 영상진단 - 회원가입",
  //   },
  // },
  {
    path: "/logout",
    name: "Logout",
    component: Logout,
    meta: {
      title: "병해충 영상진단 - 로그아웃",
      roles: ["manager"],
    },
  },
  {
    path: "/",
    redirect: "/analysis/disease/tomato",
    name: "Home",
    component: TheContainer,
    meta: {
      title: "병해충 영상진단",
      roles: ["manager"],
    },
    children: [
      {
        path: "/analysis/disease/tomato",
        name: "병해충 분석요청(토마토)",
        component: TomatoDiseaseAnalysis,
        meta: {
          title: "병해충 분석요청(토마토)",
          roles: ["manager"],
        },
      },
      {
        path: "/analysis/disease/strawberry",
        name: "병해충 분석요청(딸기)",
        component: StrawberryDiseaseAnalysis,
        meta: {
          title: "병해충 분석요청(딸기)",
          roles: ["manager"],
        },
      },
      {
        path: "/analysis/disease/paprika",
        name: "병해충 분석요청(파프리카)",
        component: PaprikaDiseaseAnalysis,
        meta: {
          title: "병해충 분석요청(파프리카)",
          roles: ["manager"],
        },
      },
      {
        path: "/analysis/disease/info",
        redirect: "/analysis/disease/info",
        name: "병해충 정보",
        component: {
          render(c) {
            return c("router-view");
          },
        },
        meta: {
          title: "병해충 영상진단 - 병해충 정보",
          roles: ["manager"],
        },
        children: [
          {
            path: "",
            name: "목록",
            component: DiseaseInfo,
            meta: {
              title: "병해충 영상진단 - 병해충 정보",
              roles: ["manager"],
            },
          },
          {
            path: "add",
            name: "추가",
            component: DiseaseInfoAddEdit,
            meta: {
              title: "병해충 영상진단 - 병해충 정보 추가",
              roles: ["manager"],
            },
          },
          {
            path: "edit",
            name: "수정",
            component: DiseaseInfoAddEdit,
            meta: {
              title: "병해충 영상진단 - 병해충 정보 수정",
              roles: ["manager"],
            },
          },
        ],
      },
    ],
  },
];

const router = new Router({
  mode: "history", // https://router.vuejs.org/api/#mode
  linkActiveClass: "active",
  scrollBehavior: () => ({ y: 0 }),
  routes: routes,
});

function childrenRouteMap(path, children) {
  children.forEach((data) => {
    let slash = "";
    if (path.substr(path.length - 1, path.length) !== "/") {
      slash = "/";
    }
    const _path = path + slash + data.path;
    if (data.children != null) {
      childrenRouteMap(_path, data.children);
    } else {
      if (routeMap.get(_path) != null) {
        console.log("중복 path : ", _path);
      }
      routeMap.set(_path, data);
    }
  });
}

const routeMap = new Map();
routes.forEach((data) => {
  if (data.children != null) {
    childrenRouteMap(data.path, data.children);
  } else {
    if (routeMap.get(data.path) != null) {
      console.log("중복 path : ", data.path);
    }
    routeMap.set(data.path, data);
  }
});

const routerBeforeTask = store.state.routerBeforeTask;
router.beforeEach(async (to, from, next) => {
  if (!routerBeforeTask.isRouterNext()) {
    //console.log("ignore router event");
    next(false);
    return;
  } else {
    const viewerContainer = document.querySelector(".viewer-container.viewer-in");
    if (viewerContainer != null) {
      next(false);
      const button = viewerContainer.querySelector(".viewer-button");
      if (button != null) {
        button.click();
      }
      return;
    }
  }

  //console.log("from   : ", from);
  //console.log("to     : ", to);
  core.loader.show("페이지 로딩중...");

  // console.log("from " + from.path + " -> to : " + to.path);
  document.title = await beforeEach(to, from, next);
  core.loader.hide();
});

function routerResult(next, path) {
  next({ path: path });
  //console.log("next : ", path);
  const route = routeMap.get(path);
  if (route != null && route.meta != null && route.meta.title != null) {
    return route.meta.title;
  } else "";
}

async function beforeEach(to, from, next) {
  const state = store.state;
  if (state.auth.user) {
    // 로그인 중인 사용자
    if (to.meta.roles != null) {
      // 로그인 사용자 접근 가능 페이지일 경우 이동
      next();
    } else {
      // 비로그인 사용자 접근 가능 페이지일 경우 이동
      if (to.path.toLowerCase() === "/login") {
        // 로그인중인 사용자가 로그인 페이지 접근시 이동
        return routerResult(next, "/");
      } else {
        next();
      }
    }
  } else {
    // 비로그인 중인 사용자 세션 확인
    const user = await store.dispatch("auth/getUser");
    if (user != null) {
      // 세션이 존재하면 로그인중인 사용자로 변경되어 재호출 처리
      await beforeEach(to, from, next);
    } else {
      if (to.meta.roles != null) {
        // 로그인 사용자 접근 가능 페이지일 경우 메인 페이지로 이동
        return routerResult(next, "/login");
      } else {
        next();
      }
    }
  }
  if (to.meta != null && to.meta.title != null) {
    return to.meta.title;
  } else {
    return "";
  }
}

export default router;
